import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import FinanceBox from './financeBox';
import PEBox from './peBox';

class FPNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { financeData, peData, financeAndPeAd },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <FinanceBox content={financeData} />
                    <PEBox content={peData} />
                </div>
                {financeAndPeAd ? <Ad content={financeAndPeAd} styleName={styles.financeAndPeAd} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(FPNews);
